import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import { MaterialUIControllerProvider } from "./Context/mui";
import { Provider } from "react-redux";
import { Store } from "./Context/redux/store";
import "./index.css";
import "./i18n";
ReactDOM.render(
  <BrowserRouter>
    <Provider store={Store}>
      <MaterialUIControllerProvider>
        <App />
      </MaterialUIControllerProvider>
    </Provider>
  </BrowserRouter>,

  document.getElementById("root")
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
